export const SAVE_LG_PDF = "learning-goals-pdf/SAVE_LG_PDF";
export const SAVE_LG_PDF_SUCCESS = "learning-goals-pdf/SAVE_LG_PDF_SUCCESS";